var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePersonalcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 21.75c-4.41 0-5.75-1.34-5.75-5.75V8c0-4.41 1.34-5.75 5.75-5.75h10c4.41 0 5.75 1.34 5.75 5.75v8c0 4.41-1.34 5.75-5.75 5.75H7zM2.75 8v8c0 3.57.67 4.25 4.25 4.25h10c3.58 0 4.25-.68 4.25-4.25V8c0-3.57-.67-4.25-4.25-4.25H7c-3.58 0-4.25.68-4.25 4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5zM15 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM17 16.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75h-2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94 9.48c0-1.41 1.15-2.56 2.56-2.56 1.41 0 2.56 1.15 2.56 2.56 0 1.41-1.15 2.56-2.56 2.56-1.41 0-2.56-1.15-2.56-2.56zm1.5 0c0 .58.48 1.06 1.06 1.06.58 0 1.06-.48 1.06-1.06 0-.58-.48-1.06-1.06-1.06-.58 0-1.06.48-1.06 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.4a2.301 2.301 0 0 0-2.07-2.05 7.95 7.95 0 0 0-1.38 0c-1.09.1-1.96.96-2.07 2.05-.04.41-.41.72-.82.67a.75.75 0 0 1-.67-.82c.18-1.8 1.61-3.23 3.42-3.39.55-.05 1.11-.05 1.66 0 1.8.17 3.24 1.6 3.42 3.39a.75.75 0 0 1-.67.82c-.02.01-.05.01-.07.01-.38 0-.71-.29-.75-.68z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePersonalcard);
export default __webpack_public_path__ + "static/media/vuesax-outline-personalcard.b453f3cb7a7e3c93ec56690c7b24081f.svg";
export { ForwardRef as ReactComponent };